module.exports = __webpack_public_path__ + "img/partner 05.c04a9e87.jpg";